import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'




const routes: Array<RouteRecordRaw> = [
{
  path: '/',
  name: 'home',
  component: HomeView
},
{
  path: '/about',
  name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/Card-service',
    name: 'Card-dervice',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Services/cardService.vue')
  },
  {
    path: '/Cabin-service',
    name: 'Cabin-service',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Services/Cabin-service.vue')
  },
  {
    path: '/Diagnostics',
    name: 'Diagnostics',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Services/Diagnostics.vue')
  },
  {
    path: '/doctors',
    name: 'doctors',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/doctors.vue')
  },

  {
    path: '/doctor-details/:id',
    name: 'doctor-details',
    props: true,
    component: () => import('../views/doctorDtails.vue')

  },
  {
    path: '/service-details/:id',
    name: 'service-details',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/serviceDetails.vue')
  },
  {
    path: '/manegments/:id',
    name: 'managementDetail',  
    props: true,  // This allows passing the `id` from the route as a prop to the component
    component: () => import(/* webpackChunkName: "management" */ '../views/Management/manegments.vue')
  },
  
  {
    path: '/contactUs',
    name: 'contactUs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/contactUs/contactUs.vue')
  },
  {
    path: '/ICU',
    name: 'ICU',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/Icu.vue')
  },
  {
    path: '/NICU',
    name: 'NICU',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/NICU.vue')
  },
  {
    path: '/CCU',
    name: 'CCU',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/CCU.vue')
  }, 
  {
    path: '/HDU',
    name: 'HDU',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/HDU.vue')
  },
  {
    path: '/DiabeticClub',
    name: 'DiabeticClub',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/DiabeticClub.vue')
  },
  {
    path: '/Dentistry',
    name: 'Dentistry',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/Dentistry.vue')
  },
    {
    path: '/Pediatric',
    name: 'Pediatric',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/Pediatric.vue')
  },
  {
    path: '/EPICorner',
    name: 'EPICorner',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/EPICorner.vue')
  },
  {
    path: '/BloodBank',
    name: 'BloodBank',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/BloodBank.vue')
  },

  {
    path: '/MedicineAllied',
    name: 'MedicineAllied',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/MedicineAllied.vue')
  },
  {
    path: '/SurgeryAllied',
    name: 'SurgeryAllied',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/SurgeryAllied.vue')
  },
  {
    path: '/Obsgynae',
    name: 'Obsgynae',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/Obsgynae.vue')
  },
  {
    path: '/Emergency',
    name: 'Emergency',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Department/Emergency.vue')
  },
  {
    path: '/appointment',
    name: 'appointment',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/appointment/appointment.vue')
  },
  {
    path: '/Caner_Center',
    name: 'Caner_Center',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CanerCenter/CanerCenter.vue')
  },
  {
    path: '/CardiacCenter',
    name: 'CardiacCenter',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CardiacCenter/CardiacCenter.vue')
  },
  {
    path: '/UrologyCenter',
    name: 'UrologyCenter',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/UrologyCenter/UrologyCenter.vue')
  },
  {
    path: '/IVFCenter',
    name: 'IVFCenter',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/IVFCenter/IVFCenter.vue')
  },
  {
    path: '/CSSD',
    name: 'CSSD',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CSSD/CSSD.vue')
  },
  {
    path: '/Dialysis_Center',
    name: 'Dialysis_Center',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/DialysisCenter/DialysisCenter.vue')
  },
  {
    path: '/Chemotherapy_Center',
    name: 'Chemotherapy_Center',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/ChemotherapyCenter/ChemotherapyCenter.vue')
  },
  {
    path: '/Physiotherapy_Center',
    name: 'Physiotherapy_Center',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/PhysiotherapyCenter/PhysiotherapyCenter.vue')
  },
  {
    path: '/NewsEvent',
    name: 'NewsEvent',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/NewsEvent/NewsEvent.vue')
  },
  {
    path: '/ComplaintBox',
    name: 'ComplaintBox',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/contactUs/ComplaintBox.vue')
  },
  {
    path: '/Career',
    name: 'Career',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Career/Career.vue')
  },
  {
    path: '/Notice',
    name: 'Notice',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Notice/Notice.vue')
  },
  {
    path: '/Job_apply',
    name: 'Job_apply',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Job_apply/Job_apply.vue')
  },
  ]

  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
  })

  export default router
